module.exports = "button {\n  background: none !important; }\n"